module.exports = __webpack_public_path__ + "img/2.ad187aff.jpg";